import MListItem from "@mui/material/ListItem";
import MListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";

const ListItem = styled(MListItem)({});

const ListItemText = styled(MListItemText)(() => ({}));

export { ListItem, ListItemText };
